<template>
  <AdminLayout>
    <template #breadcrumb>
      <breadcrumb-link
        view="AdminPatientVerificationList"
        label="Patient Verifications"
        :active="true"
      />
    </template>
    <div class="box">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Patient Verification History</h1>
          </div>
        </div>
      </div>
      <hr />
      <PatientVerificationTable :admin-mode="true" />
    </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from '../../layouts/AdminLayout.vue';
import PatientVerificationTable from '../../components/PatientVerificationTable.vue';
export default {
  name: 'AdminPatientVerificationList',
  components: { AdminLayout, PatientVerificationTable },
};
</script>
